(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[269],{

/***/ 2637:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function ArrowRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 9204:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function ArrowTopRightOnSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.25 5.5a.75.75 0 00-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 00.75-.75v-4a.75.75 0 011.5 0v4A2.25 2.25 0 0112.75 17h-8.5A2.25 2.25 0 012 14.75v-8.5A2.25 2.25 0 014.25 4h5a.75.75 0 010 1.5h-5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.194 12.753a.75.75 0 001.06.053L16.5 4.44v2.81a.75.75 0 001.5 0v-4.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h2.553l-9.056 8.194a.75.75 0 00-.053 1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowTopRightOnSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function CodeBracketIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.28 5.22a.75.75 0 010 1.06L2.56 10l3.72 3.72a.75.75 0 01-1.06 1.06L.97 10.53a.75.75 0 010-1.06l4.25-4.25a.75.75 0 011.06 0zm7.44 0a.75.75 0 011.06 0l4.25 4.25a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.06-1.06L17.44 10l-3.72-3.72a.75.75 0 010-1.06zM11.377 2.011a.75.75 0 01.612.867l-2.5 14.5a.75.75 0 01-1.478-.255l2.5-14.5a.75.75 0 01.866-.612z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CodeBracketIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 8685:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function CurrencyEuroIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.798 7.45c.512-.67 1.135-.95 1.702-.95s1.19.28 1.702.95a.75.75 0 001.192-.91C12.637 5.55 11.596 5 10.5 5s-2.137.55-2.894 1.54A5.205 5.205 0 006.83 8H5.75a.75.75 0 000 1.5h.77a6.333 6.333 0 000 1h-.77a.75.75 0 000 1.5h1.08c.183.528.442 1.023.776 1.46.757.99 1.798 1.54 2.894 1.54s2.137-.55 2.894-1.54a.75.75 0 00-1.192-.91c-.512.67-1.135.95-1.702.95s-1.19-.28-1.702-.95a3.505 3.505 0 01-.343-.55h1.795a.75.75 0 000-1.5H8.026a4.835 4.835 0 010-1h2.224a.75.75 0 000-1.5H8.455c.098-.195.212-.38.343-.55z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CurrencyEuroIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 1674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function EyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.664 10.59a1.651 1.651 0 010-1.186A10.004 10.004 0 0110 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0110 17c-4.257 0-7.893-2.66-9.336-6.41zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(EyeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 3656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function FaceSmileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.536-4.464a.75.75 0 10-1.061-1.061 3.5 3.5 0 01-4.95 0 .75.75 0 00-1.06 1.06 5 5 0 007.07 0zM9 8.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S7.448 7 8 7s1 .672 1 1.5zm3 1.5c.552 0 1-.672 1-1.5S12.552 7 12 7s-1 .672-1 1.5.448 1.5 1 1.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FaceSmileIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 8171:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function GlobeAltIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.555 5.412a8.028 8.028 0 00-3.503-2.81 14.899 14.899 0 011.663 4.472 8.547 8.547 0 001.84-1.662zM13.326 7.825a13.43 13.43 0 00-2.413-5.773 8.087 8.087 0 00-1.826 0 13.43 13.43 0 00-2.413 5.773A8.473 8.473 0 0010 8.5c1.18 0 2.304-.24 3.326-.675zM6.514 9.376A9.98 9.98 0 0010 10c1.226 0 2.4-.22 3.486-.624a13.54 13.54 0 01-.351 3.759A13.54 13.54 0 0110 13.5c-1.079 0-2.128-.127-3.134-.366a13.538 13.538 0 01-.352-3.758zM5.285 7.074a14.9 14.9 0 011.663-4.471 8.028 8.028 0 00-3.503 2.81c.529.638 1.149 1.199 1.84 1.66zM17.334 6.798a7.973 7.973 0 01.614 4.115 13.47 13.47 0 01-3.178 1.72 15.093 15.093 0 00.174-3.939 10.043 10.043 0 002.39-1.896zM2.666 6.798a10.042 10.042 0 002.39 1.896 15.196 15.196 0 00.174 3.94 13.472 13.472 0 01-3.178-1.72 7.973 7.973 0 01.615-4.115zM10 15c.898 0 1.778-.079 2.633-.23a13.473 13.473 0 01-1.72 3.178 8.099 8.099 0 01-1.826 0 13.47 13.47 0 01-1.72-3.178c.855.151 1.735.23 2.633.23zM14.357 14.357a14.912 14.912 0 01-1.305 3.04 8.027 8.027 0 004.345-4.345c-.953.542-1.971.981-3.04 1.305zM6.948 17.397a8.027 8.027 0 01-4.345-4.345c.953.542 1.971.981 3.04 1.305a14.912 14.912 0 001.305 3.04z"
  }));
}

const ForwardRef = React.forwardRef(GlobeAltIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 5530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function CheckCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CheckCircleIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 1565:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kansenongelijkheid",
      function () {
        return __webpack_require__(6541);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9451:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/marketplace.765b9224.png","height":1834,"width":2730,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAIVBMVEX9/v7i5ObJy87X2Nzp6+1rcYK4u7/c3uDP0dSMjpeUmaZClIIZAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAKklEQVR4nC3IQQ4AIAgDwaVFAf//YGPibTJMhrDhkMIFi9h0P6Sp+CNxAQrrAHG8HKkPAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 5275:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wave.da42d7ec.png","height":275,"width":1292,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAHlBMVEX////////////////////////////+/v7+/v7///8m/k5LAAAACnRSTlP7Eejnw7mPWzgszLouIgAAAAlwSFlzAAALEwAACxMBAJqcGAAAABZJREFUeJxjYGFlY+dkZORgAANmZgYAAk0AMGCs67cAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 4778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ CallToAction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Button.jsx
var Button = __webpack_require__(1109);
// EXTERNAL MODULE: ./src/components/Container.jsx
var Container = __webpack_require__(7527);
;// CONCATENATED MODULE: ./src/images/background-call-to-action.jpg
/* harmony default export */ var background_call_to_action = ({"src":"/_next/static/media/background-call-to-action.6a5a5672.jpg","height":2488,"width":4694,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAbEAADAAIDAAAAAAAAAAAAAAAAAQIRIQMEE//EABQBAQAAAAAAAAAAAAAAAAAAAAb/xAAYEQACAwAAAAAAAAAAAAAAAAAAAQIyQf/aAAwDAQACEQMRAD8AnRafW5F5xmVp42AB5HQ87M//2Q==","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/GlobeAltIcon.js
var GlobeAltIcon = __webpack_require__(8171);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/FaceSmileIcon.js
var FaceSmileIcon = __webpack_require__(3656);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/EyeIcon.js
var EyeIcon = __webpack_require__(1674);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/CurrencyEuroIcon.js
var CurrencyEuroIcon = __webpack_require__(8685);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/CodeBracketIcon.js
var CodeBracketIcon = __webpack_require__(4393);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/ArrowTopRightOnSquareIcon.js
var ArrowTopRightOnSquareIcon = __webpack_require__(9204);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(2637);
;// CONCATENATED MODULE: ./src/components/CallToAction.jsx







const features = [
    {
        name: "Binnen 1 dag online",
        description: "",
        icon: GlobeAltIcon
    },
    {
        name: "Stimuleert leerplezier",
        description: "",
        icon: FaceSmileIcon
    },
    {
        name: "Overzichtelijk en goedkoop",
        description: "",
        icon: EyeIcon
    },
    {
        name: "Valt onder NPO-gelden",
        description: "",
        icon: CurrencyEuroIcon
    },
    {
        name: "Maatwerk mogelijk",
        description: "",
        icon: CodeBracketIcon
    }
];
function CallToAction() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "waarom-bijlesplein",
        className: "relative overflow-hidden bg-blue-600 py-32",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: "absolute top-1/2 left-1/2 max-w-none -translate-x-1/2 -translate-y-1/2",
                src: background_call_to_action,
                alt: "",
                width: 2347,
                height: 1244,
                unoptimized: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                className: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-4xl text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-display text-3xl tracking-tight text-white sm:text-4xl",
                        children: "Waarom Bijlesplein?"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto max-w-7xl px-6 lg:px-8 my-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                    className: "mx-auto flex flex-wrap justify-center max-w-2xl grid-cols-1 gap-6 text-base leading-7 text-white sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-5 lg:gap-8",
                    children: features.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative pl-9 whitespace-nowrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                    className: "inline font-semibold text-white",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                            className: "absolute left-1 top-1 h-5 w-5 text-white",
                                            "aria-hidden": "true"
                                        }),
                                        feature.name
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "inline",
                                    children: feature.description
                                })
                            ]
                        }, feature.name))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                className: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-4xl text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mt-5 text-lg text-white",
                            children: [
                                "Als onderwijsinstelling wil je de vraag naar bijles zelf regelen om een goed alternatief te bieden voor commerci\xeble bijlesaanbieders. Het heeft meerdere voordelen wanneer leerlingen en studenten zelf elkaar na lestijd helpen. Meer leerplezier, eigenaarschap van het eigen leren en sociale binding met elkaar. Inmiddels is bewezen dat het een positief effect heeft wanneer leerlingen van elkaar leren.",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "hover:opacity-70",
                                    href: "https://nos.nl/nieuwsuur/artikel/2408491-onderwijsraad-waarschuwt-voor-kansenongelijkheid-door-private-bijles",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: [
                                        " Artikel over kansengelijkheid. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowTopRightOnSquareIcon, {
                                            className: "inline-flex h-4 w-4 text-white mb-1"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-display text-2xl tracking-tight text-white mt-10 mb-1",
                            children: "Kansongelijkheid"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-lg text-white",
                            children: "Als onderwijsinstelling heb je ook een verantwoordelijkheid als het gaat om kansongelijkheid. Commerci\xeble bijles is alleen bereikbaar voor ouders met een goed inkomen. Met Bijlesplein stimuleer je bijles tegen een laag tarief. Het is een kant-en-klaar platform waar leerlingen en studenten een mede-scholier kunnen vinden voor bijles en waar de leerlingen en studenten hun diensten kunnen aanbieden."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-x-6 mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    href: "/register",
                                    color: "white",
                                    className: "mt-10",
                                    contact: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: "group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-slate-900 text-white hover:bg-slate-700 hover:text-slate-100 active:bg-slate-800 active:text-slate-300 focus-visible:outline-slate-900",
                                    href: "/demo",
                                    children: "Vraag gratis demo aan"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            href: "/tips-bijles-organiseren",
                            className: "text-white hover:opacity-70 font-semibold text-lg",
                            children: [
                                "5 tips voor betere bijles ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon, {
                                    className: "w-4 h-4 mb-0.5 inline-flex"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 2055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeaderSimple; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _images_wave_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5275);



function HeaderSimple(param) {
    let { image , top_title , title , text  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white",
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative h-60 sm:h-[27rem] overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: image,
                        alt: "Main image",
                        className: "h-full w-full object-cover"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: _images_wave_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                        alt: "Wave",
                        className: "h-24 w-full absolute -bottom-10"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto max-w-5xl py-6 px-6 sm:py-16 lg:px-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-center",
                    children: [
                        top_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-lg font-semibold text-blue-600",
                            children: top_title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-1 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl font-display",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mx-auto mt-6 max-w-2xl text-lg text-gray-600 text-left",
                            children: text
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 4978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WhitepaperCta; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(196);
;// CONCATENATED MODULE: ./src/images/whitepaper-cover.png
/* harmony default export */ var whitepaper_cover = ({"src":"/_next/static/media/whitepaper-cover.e95cc48b.png","height":1200,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAYFBMVEU8RoLv8vlsW0aftu4ANM4lKiF1fXlARHSirKze4ejX19c6ZNZAQTUAB67k5+xdhet8YEtjSjgzNizQz9JifXjj5uafk4i/v8BUWE9rcWSVr/FNQTCrv/EvKh5ycma8uboisjtsAAAAG3RSTlMB+/vrP2MgETn+IGX2I2L4/vxL/jlK/f3x6/JicfvgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQUlEQVR4nCXLRxKAIBAAwQERds05Ifr/X1qUt740IIsPAOF8jqYEvI1jypDNDnECVp3fXYDOqJoKqPvrLv7WOgcfWMsCVdqJwxQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/WhitepaperCta.jsx






function download(url, filename) {
    fetch(url).then(function(t) {
        return t.blob().then((b)=>{
            var a = document.createElement("a");
            a.href = URL.createObjectURL(b);
            a.setAttribute("download", filename);
            a.click();
        });
    });
}
function WhitepaperCta() {
    const [success, setSuccess] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)(null);
    const { register , handleSubmit , formState: { errors  }  } = (0,index_esm/* useForm */.cI)();
    const onSubmit = (data)=>{
        axios/* default.post */.ZP.post("/api/subscribe", {
            email: data.email,
            tags: [
                "Whitepaper"
            ]
        }).then(function(response) {
            setError(null);
            setSuccess(true);
            download("https://bijlesplein.nl/files/whitepaper.pdf", "whitepaper.pdf");
        }).catch(function(error) {
            var ref, ref1;
            if (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
                setError(error.response.data.message);
            } else {
                setError("Er ging iets mis bij het versturen van het formulier. Probeer het later opnieuw.");
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white py-16 sm:py-24 lg:py-32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto max-w-7xl px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-xl text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "inline sm:block",
                                        children: "Download onze whitepaper"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-xl sm:text-2xl",
                                        children: "over kansenongelijkheid in het onderwijs"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: whitepaper_cover,
                                className: "w-60 h-auto"
                            })
                        ]
                    })
                }),
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rounded-md bg-red-50 p-4 mt-4 -mb-5 max-w-md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-shrink-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    strokeWidth: "1.5",
                                    stroke: "currentColor",
                                    className: "h-5 w-5 text-red-400",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        d: "M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-sm font-medium text-red-800",
                                    children: error
                                })
                            })
                        ]
                    })
                }),
                success ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rounded-md bg-green-50 p-4 mt-4 max-w-md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-shrink-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    strokeWidth: "1.5",
                                    stroke: "currentColor",
                                    className: "h-5 w-5 text-green-400",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "ml-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-sm font-medium text-green-800",
                                        children: "Aanvraag succesvol"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-2 text-sm text-green-700",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "De download voor het whitepaper start automatisch. Gebeurt dat niet? ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/whitepaper",
                                                    target: "_blank",
                                                    className: "font-semibold hover:opacity-80 hover:underline",
                                                    children: "Klik dan hier"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    className: "mt-10 max-w-md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col sm:flex-row gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "email-address",
                                    className: "sr-only",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    id: "email-address",
                                    name: "email",
                                    type: "email",
                                    autoComplete: "email",
                                    required: true,
                                    className: "min-w-0 flex-auto rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6",
                                    placeholder: "Vul je email in",
                                    ...register("email", {
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    className: "flex-none rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600",
                                    children: "Download whitepaper"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mt-4 text-sm leading-6 text-gray-900",
                            children: [
                                "Wij geven om jouw data. Lees ons",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/files/privacy.pdf",
                                    className: "font-semibold text-blue-600 hover:text-blue-500",
                                    children: "privacybeleid"
                                }),
                                "."
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 6541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Kansenongelijkheid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Header.jsx
var Header = __webpack_require__(7027);
// EXTERNAL MODULE: ./src/components/HeaderSimple.jsx
var HeaderSimple = __webpack_require__(2055);
// EXTERNAL MODULE: ./src/components/CallToAction.jsx + 1 modules
var CallToAction = __webpack_require__(4778);
// EXTERNAL MODULE: ./src/components/Footer.jsx
var Footer = __webpack_require__(3862);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/CurrencyEuroIcon.js
var CurrencyEuroIcon = __webpack_require__(8685);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/CheckCircleIcon.js
var CheckCircleIcon = __webpack_require__(5530);
// EXTERNAL MODULE: ./src/images/screenshots/marketplace.png
var marketplace = __webpack_require__(9451);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/solid/esm/UserGroupIcon.js


function UserGroupIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M8.25 6.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM15.75 9.75a3 3 0 116 0 3 3 0 01-6 0zM2.25 9.75a3 3 0 116 0 3 3 0 01-6 0zM6.31 15.117A6.745 6.745 0 0112 12a6.745 6.745 0 016.709 7.498.75.75 0 01-.372.568A12.696 12.696 0 0112 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 01-.372-.568 6.787 6.787 0 011.019-4.38z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M5.082 14.254a8.287 8.287 0 00-1.308 5.135 9.687 9.687 0 01-1.764-.44l-.115-.04a.563.563 0 01-.373-.487l-.01-.121a3.75 3.75 0 013.57-4.047zM20.226 19.389a8.287 8.287 0 00-1.308-5.135 3.75 3.75 0 013.57 4.047l-.01.121a.563.563 0 01-.373.486l-.115.04c-.567.2-1.156.349-1.764.441z"
  }));
}

const ForwardRef = react.forwardRef(UserGroupIcon);
/* harmony default export */ var esm_UserGroupIcon = (ForwardRef);
// EXTERNAL MODULE: ./src/components/WhitepaperCta.jsx + 1 modules
var WhitepaperCta = __webpack_require__(4978);
;// CONCATENATED MODULE: ./src/images/girls-book.jpeg
/* harmony default export */ var girls_book = ({"src":"/_next/static/media/girls-book.82d14454.jpeg","height":4016,"width":6016,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAH/xAAfEAABBAEFAQAAAAAAAAAAAAACAAEEEQMFEhMhMUH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAFhEAAwAAAAAAAAAAAAAAAAAAAAEh/9oADAMBAAIRAxEAPwC6G8uUPPmnZz3wMhEJFbPZvXXnTNXn1ERDdGqH/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/pages/kansenongelijkheid.jsx













const features = [
    {
        name: "Netwerk",
        description: "Biedt toegang tot een netwerk met leerlingen die kunnen helpen met huiswerk en bijles\n",
        icon: esm_UserGroupIcon
    },
    {
        name: "Financieel",
        description: "Afhankelijk van de keuzes van school is deze ondersteuning niet duur of zelfs gratis\n",
        icon: CurrencyEuroIcon
    }
];
const benefits = [
    "het tarief is vele malen lager dan met een commerci\xeble partij (als school kun je zelfs kiezen dit deels gratis aan te bieden)",
    "uit onderzoek is gebleken dat tutoring tussen leerlingen onderling veel effectiever is",
    "leerlingen die bijles geven doen waardevolle ervaring op",
    "als school heb je veel minder administratielast over de bijlessen, die tijd kun je besteden aan de kwaliteit van het onderwijs\n",
    "het is een kant-en-klaar platform, binnen 1 dag online"
];
function Kansenongelijkheid() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Kansenongelijkheid",
                description: "Onze missie is: kansenongelijkheid verkleinen en zoveel mogelijk scholen hierbij helpen. We denken \xe9cht dat we een simpele en effectieve oplossing hebben voor scholen."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSimple/* default */.Z, {
                        image: girls_book,
                        title: "Hoe Bijlesplein de kansenongelijkheid verkleint",
                        text: "Onze missie is: kansenongelijkheid verkleinen en zoveel mogelijk scholen hierbij helpen. We denken \xe9cht dat we een simpele, goedkope en effectieve oplossing hebben voor scholen. Het voelt een beetje in de categorie “Wij van WC-eend”. Want we zijn inderdaad een commerci\xeble partij die haar product onder de aandacht brengt. Maar wel oprecht met de missie om de kansenongelijkheid in het onderwijs te verkleinen. Waarom dit belangrijk is en hoe Bijlesplein hier een bijdrage aan kan leveren, lees je hieronder. "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                        className: "mb-10 border-l border-blue-600 pl-9 max-w-xl mx-auto px-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                            className: "font-semibold text-gray-900 text-xl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Kansenongelijkheid = Leerlingen of studenten met dezelfde talenten krijgen niet dezelfde kansen."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative isolate overflow-hidden bg-white px-6 py-20 lg:overflow-visible lg:px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:pr-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "lg:max-w-lg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl",
                                                    children: "Oorzaken kansenongelijkheid"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mt-6 text-xl leading-8 text-gray-700",
                                                    children: "Er zijn meerdere oorzaken* die ervoor zorgen dat niet alle leerlingen dezelfde kansen krijgen in het onderwijs."
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "-ml-12 -mt-12 p-12 lg:sticky lg:top-20 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhitepaperCta/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:pr-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                role: "list",
                                                className: "mt-8 space-y-8 text-gray-600",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "flex gap-x-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "font-semibold text-gray-900",
                                                                    children: "Invloed uit de samenleving."
                                                                }),
                                                                " Bijvoorbeeld het onderwijssysteem waarbij wordt besloten welk onderwijsniveau een 12-jarige gaat volgen. Dat is soms te vroeg. Of dat kinderen uit dezelfde wijk met een vergelijkbare sociaaleconomische achtergrond bij elkaar in de klas komen. Vooral in kansarme wijken kan dit negatieve gevolgen hebben."
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "flex gap-x-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "font-semibold text-gray-900",
                                                                    children: "Invloed van school."
                                                                }),
                                                                " In het Nederlandse onderwijssysteem overheersen de cultuur en normen van de middenklasse – en hogere klasse. Daardoor is het voor kinderen uit een lagere sociaaleconomische klasse vaak moeilijker om hun weg te vinden in het schoolsysteem. Bijvoorbeeld omdat zij thuis of van leeftijdsgenoten op straat andere regels hebben geleerd."
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "flex gap-x-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "font-semibold text-gray-900",
                                                                    children: "Invloed van kinderen zelf."
                                                                }),
                                                                " De intelligentie, motivatie om te leren, gezondheid en het zelfvertrouwen van kinderen be\xefnvloeden hun kansen op school. Voor jongeren met een andere culturele achtergrond is dat soms moeilijker omdat zij verschillende culturele invloeden ervaren."
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "flex gap-x-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "font-semibold text-gray-900",
                                                                    children: "Mogelijkheden van ouders."
                                                                }),
                                                                " Het hangt bijvoorbeeld af van hun onderwijsniveau, het netwerk en de steun die zij krijgen van vrienden en familie. Maar ook welke (financi\xeble) mogelijkheden zij hebben om te helpen bij schoolwerk."
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "flex gap-x-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "font-semibold text-gray-900",
                                                                    children: "Samenhang tussen factoren."
                                                                }),
                                                                " Bovenstaande factoren zijn van invloed op elkaar of hangen met elkaar samen. Het aanpakken van kansenongelijkheid in het onderwijs heeft daarom een integrale aanpak nodig."
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-white py-20 sm:py-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-auto max-w-7xl px-6 lg:px-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto max-w-2xl lg:text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl",
                                        children: "Waar Bijlesplein een rol in kan spelen is het stuk waar ouders beperkte mogelijkheden hebben om hun kinderen te helpen. Bijlesplein:"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                                        className: "grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16",
                                        children: features.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative pl-16",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                                        className: "text-base font-semibold leading-7 text-gray-900",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-600",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                                                    className: "h-6 w-6 text-white",
                                                                    "aria-hidden": "true"
                                                                })
                                                            }),
                                                            feature.name
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                        className: "mt-2 text-base leading-7 text-gray-600",
                                                        children: feature.description
                                                    })
                                                ]
                                            }, feature.name))
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto max-w-3xl text-base leading-7 text-gray-700",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-10 max-w-2xl",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-2xl font-bold tracking-tight text-gray-900",
                                    children: "Bied gratis of tegen een laag tarief bijles aan tussen leerlingen onderling"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-6",
                                    children: "We begrijpen dat je als onderwijsinstelling kiest voor commerci\xeble bijlesaanbieders. Want ja, je zit al krap in je capaciteit. Maar, niet alle ouders kunnen dat betalen. Terwijl je als school ook verantwoordelijkheid hebt als het gaat om kansenongelijkheid. Het kan anders."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-8",
                                    children: "Wat nou als je een platform hebt waarbij je vraag en aanbod van bijles tussen leerlingen onderling samenbrengt. Leerlingen die bijles willen, zoeken een medeleerling die deze les aanbiedt."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-2xl font-bold tracking-tight text-gray-900 mt-8",
                                    children: "Dat heeft 5 belangrijke voordelen:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    role: "list",
                                    className: "mt-6 max-w-xl space-y-2 text-gray-600",
                                    children: benefits.map((benefit, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "flex gap-x-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleIcon, {
                                                    className: "mt-1 h-5 w-5 flex-none text-blue-600",
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: benefit
                                                })
                                            ]
                                        }, index))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-8",
                                    children: "Wil je meer weten over hoe het werkt en hoe bijdraagt aan kansengelijkheid? Neem contact met ons op."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-8 text-sm opacity-70 mb-8",
                                    children: "*Bron: Nederlands Jeugdinstituut"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction/* CallToAction */.J, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [695,597,774,888,179], function() { return __webpack_exec__(1565); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);